import React from "react"
import Icon from "./Icon"
import shakespeareInTheGarden from "../../../../../assets/images/channel_pages/shakespeare-in-the-garden.png"

// Instagram/Facebook post preview for "Shakespeare in the Garden" — Social channel hero.

const SocialPostPreview = () => (
  <div style={{ position: "relative", width: "100%", maxWidth: 440, margin: "0 auto" }}>
    {/* Engagement prediction chip (top-left) */}
    <div style={{
      position: "absolute", top: -18, left: -28, zIndex: 4,
      padding: "8px 12px 8px 10px",
      background: "rgba(8,28,20,.72)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      display: "flex", alignItems: "center", gap: 8,
      fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 6s ease-in-out infinite",
    }}>
      <span style={{
        width: 18, height: 18, borderRadius: 5,
        background: "linear-gradient(135deg,#34C759,#1F8A45)",
        display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
      }}>
        <Icon name="sparkles" size={11} stroke={2.4}/>
      </span>
      <span>Predicted engagement · +62%</span>
    </div>

    <div style={{
      position: "relative", zIndex: 2,
      background: "#fff", borderRadius: 16,
      boxShadow: "0 30px 80px rgba(5,40,30,.40), 0 10px 24px rgba(5,40,30,.22)",
      overflow: "hidden",
      transform: "perspective(1400px) rotateY(-6deg) rotateX(2deg)",
      transformOrigin: "center",
    }}>
      <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{
          width: 34, height: 34, borderRadius: "50%",
          background: "conic-gradient(from 210deg, #FFD166, #34C759, #193761, #FFD166)",
          padding: 2,
        }}>
          <div style={{
            width: "100%", height: "100%", borderRadius: "50%",
            background: "#fff",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 12, fontWeight: 800, color: "#0F172A", letterSpacing: "-.02em",
          }}>WG</div>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: "#0F172A", lineHeight: 1.2 }}>
            willowgate.gardens
          </div>
          <div style={{ fontSize: 11, color: "#64748B", marginTop: 1, display: "flex", alignItems: "center", gap: 5 }}>
            <span>Brooklyn, NY</span>
            <span>·</span>
            <span style={{ color: "var(--mpp-accent)", fontWeight: 600 }}>Scheduled · Wed 4:00 PM</span>
          </div>
        </div>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          padding: "4px 7px",
          background: "#F1F5F9", borderRadius: 999,
          fontSize: 10.5, fontWeight: 700, color: "#475569",
        }}>
          <span style={{ width: 10, height: 10, borderRadius: 2, background: "linear-gradient(135deg,#FFD166,#EF476F,#6A3AFB)" }}/>
          <span style={{ width: 10, height: 10, borderRadius: 2, background: "#1877F2" }}/>
          <span style={{ marginLeft: 2 }}>IG + FB</span>
        </div>
      </div>

      <div style={{
        position: "relative", aspectRatio: "1 / 1",
        overflow: "hidden",
        display: "flex", flexDirection: "column", justifyContent: "space-between",
        padding: 18,
      }}>
        <img src={shakespeareInTheGarden} alt="Shakespeare in the Garden" style={{
          position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0,
        }}/>
        <div style={{
          position: "absolute", inset: 0, zIndex: 1,
          background: "linear-gradient(180deg, rgba(5,20,15,.35) 0%, rgba(5,20,15,0) 35%, rgba(5,20,15,.65) 100%)",
        }}/>
        <div style={{
          position: "relative", zIndex: 2,
          display: "flex", justifyContent: "space-between", alignItems: "flex-start",
          color: "#fff",
        }}>
          <div style={{
            fontSize: 10, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase",
            padding: "4px 9px", borderRadius: 999,
            background: "rgba(5,20,15,.4)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,.28)",
          }}>Opens in 12 days</div>
          <div style={{
            padding: "4px 9px", borderRadius: 6,
            background: "#fff", color: "#0E2240",
            fontSize: 10, fontWeight: 800, letterSpacing: ".1em",
          }}>#MUCHADO</div>
        </div>

        <div style={{ position: "relative", zIndex: 2, color: "#fff" }}>
          <div style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: ".12em", textTransform: "uppercase", opacity: .9, marginBottom: 6, textShadow: "0 1px 6px rgba(0,0,0,.6)" }}>
            Willowgate Gardens · Brooklyn
          </div>
          <div style={{
            fontFamily: "Manrope, system-ui, sans-serif",
            fontSize: 26, lineHeight: 1.02, fontWeight: 800, letterSpacing: "-.03em",
            textShadow: "0 2px 18px rgba(0,0,0,.6)",
          }}>
            Shakespeare in the Garden
          </div>
          <div style={{ fontSize: 13, fontStyle: "italic", fontWeight: 600, opacity: .92, marginTop: 4, textShadow: "0 1px 6px rgba(0,0,0,.6)" }}>
            Much Ado About Nothing
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, opacity: .88, marginTop: 8, textShadow: "0 1px 6px rgba(0,0,0,.6)" }}>
            Tickets + picnic passes at link in bio 🌿
          </div>
        </div>
      </div>

      <div style={{ padding: "10px 14px 6px", display: "flex", alignItems: "center", gap: 14, color: "#0F172A" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          <Icon name="heart" size={16}/>
          <span style={{ fontSize: 11.5, fontWeight: 600 }}>8.7k</span>
        </div>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          <Icon name="message" size={16}/>
          <span style={{ fontSize: 11.5, fontWeight: 600 }}>624</span>
        </div>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          <Icon name="share" size={16}/>
          <span style={{ fontSize: 11.5, fontWeight: 600 }}>210</span>
        </div>
        <div style={{ marginLeft: "auto" }}><Icon name="bookmark" size={16}/></div>
      </div>

      <div style={{
        padding: "0 14px 14px",
        fontSize: 12.5, lineHeight: 1.45, color: "#0F172A",
      }}>
        <span style={{ fontWeight: 700 }}>willowgate.gardens</span>{" "}
        Outdoor Shakespeare is back. Bring a blanket, bring a bottle, bring someone you like arguing with. Beatrice and Benedick return to the garden for two weeks only.{" "}
        <span style={{ color: "var(--mpp-accent)", fontWeight: 600 }}>#brooklyntheater #outdoorshakespeare #muchadoaboutnothing</span>
      </div>
    </div>

    {/* Reach chip (top-right) */}
    <div style={{
      position: "absolute", top: 102, right: -24, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(8,28,20,.80)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 8s ease-in-out -1s infinite",
    }}>
      <div style={{ fontSize: 10, fontWeight: 600, opacity: .7, letterSpacing: ".08em", textTransform: "uppercase" }}>Organic reach</div>
      <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: "-.02em", marginTop: 2 }}>
        38.4k <span style={{ fontSize: 11, fontWeight: 700, color: "#8CEAB0" }}>▲ 2.1×</span>
      </div>
    </div>

    {/* Scheduled chip (bottom-right) */}
    <div style={{
      position: "absolute", bottom: 24, right: -44, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(255,255,255,.96)",
      borderRadius: 10,
      boxShadow: "0 14px 32px rgba(5,40,30,.26)",
      display: "flex", alignItems: "center", gap: 10,
      animation: "vsFloat 7s ease-in-out -2s infinite",
    }}>
      <div style={{
        width: 30, height: 30, borderRadius: 8,
        background: "linear-gradient(135deg, rgba(52,199,89,.15), rgba(25,55,97,.15))",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "var(--mpp-accent)",
      }}>
        <Icon name="calendar" size={15} stroke={2.2}/>
      </div>
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontSize: 10.5, fontWeight: 600, color: "#64748B", letterSpacing: ".06em", textTransform: "uppercase" }}>Queued</div>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0F172A" }}>11 posts · next 14 days</div>
      </div>
    </div>
  </div>
)

export default SocialPostPreview
